// extracted by mini-css-extract-plugin
export default {"container":"ModalPopup_container__Q2mIl","content":"ModalPopup_content__qDVes","actionsButtons":"ModalPopup_actionsButtons__yY3v-"};